export default __webpack_public_path__ + "b9ee5df15f4a2a5e22932adce0aa41b5.svg";